export default __webpack_public_path__ + "static/media/amcham_logo.1ae2bec7.webp";